import { v4 as uuidv4 } from 'uuid';

export default class UUIDHelper {
  static create() {
    return uuidv4();
  }
}
